// eslint-disable-next-line import/no-anonymous-default-export
export default {
    question: 'Question',
    remind: 'Reminder',
    ques_recommend: 'FAQ',
    ques_ans:'Feedback on progress of issues:',
    order_num: 'Ticket no.',
    response: 'Reply',
    user_ask: 'To reply, [tap Here]',
    click_here: 'To reply, [tap Here]',
    other_qus: 'Other questions',
    success_help: "We're very happy to help!",
    error_help: "We're very sorry we could not help, please tap the button below to submit feedback, and we will solve it ASAP.",
    satisfaction: 'Satisfied',
    unSatisfaction: 'Dissatisfied',
    return_ask: 'Feedback',
    '超出最大文案120字': 'Max 120 characters',
    '很抱歉，暂时没有内容推荐': 'We apologize, there are no recommended questions at the moment',
    '请输入您想咨询的问题': "Please enter the issue you're having",
    '客服中心': 'Customer service center'
}